export default "__VITE_ASSET__4f5cf0fc__"